export default function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-background-100 rounded-lg p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
              移动观影
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg">
              97影院全面适配手机和平板浏览器，无需下载安装任何App，
              打开浏览器即可畅享蓝光超清画质。播放记录云端同步，
              随时随地继续上次看到的地方。支持投屏到电视，
              大屏观影更震撼。
            </p>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-md text-sm text-foreground-700">
                <i className="ri-smartphone-line text-accent-500"></i>
                <span>手机浏览器</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-md text-sm text-foreground-700">
                <i className="ri-tablet-line text-accent-500"></i>
                <span>平板适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-md text-sm text-foreground-700">
                <i className="ri-tv-line text-accent-500"></i>
                <span>电视投屏</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 h-80 md:w-56 md:h-96 relative">
            <img
              src="https://readdy.ai/api/search-image?query=smartphone%20mockup%20displaying%20movie%20streaming%20interface%20with%20dark%20theme%20and%20warm%20golden%20accents%2C%20film%20posters%20grid%20layout%2C%20modern%20UI%20design%2C%20cinematic%20app%20screenshot%20aesthetic%2C%20no%20real%20text%20content&width=448&height=768&seq=app-mobile-97&orientation=portrait"
              alt="97影院移动端观影界面展示"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}